<a class="usa-skipnav" href="#main-content">Skip to main content</a>

<section class="usa-banner" aria-label="Official government website">
  <div class="usa-accordion">
    <header class="usa-banner__header">
      <div class="usa-banner__inner">
        <div class="grid-col-auto">
          <img
            class="usa-banner__header-flag"
            src="./assets/img/us_flag_small.png"
            alt="U.S. flag"
          />
        </div>
        <div class="grid-col-fill tablet:grid-col-auto">
          <p class="usa-banner__header-text">
            An official website of the United States government
          </p>
          <p class="usa-banner__header-action" aria-hidden="true">
            Here’s how you know
          </p>
        </div>
        <button
          class="usa-accordion__button usa-banner__button"
          aria-expanded="false"
          aria-controls="gov-banner"
        >
          <span class="usa-banner__button-text">Here’s how you know</span>
        </button>
      </div>
    </header>
    <div
      class="usa-banner__content usa-accordion__content"
      id="gov-banner"
      hidden
    >
      <div class="grid-row grid-gap-lg">
        <div class="usa-banner__guidance tablet:grid-col-6">
          <img
            class="usa-banner__icon usa-media-block__img"
            src="./assets/img/icon-dot-gov.svg"
            alt="Dot gov"
          />
          <div class="usa-media-block__body">
            <p>
              <strong>The .gov means it’s official.</strong>
              <br />
              Federal government websites often end in .gov or .mil. Before
              sharing sensitive information, make sure you’re on a federal
              government site.
            </p>
          </div>
        </div>
        <div class="usa-banner__guidance tablet:grid-col-6">
          <img
            class="usa-banner__icon usa-media-block__img"
            src="./assets/img/icon-https.svg"
            alt="Https"
          />
          <div class="usa-media-block__body">
            <p>
              <strong>The site is secure.</strong>
              <br />
              The <strong>https://</strong> ensures that you are connecting to
              the official website and that any information you provide is
              encrypted and transmitted securely.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="usa-overlay"></div>
<header class="usa-header usa-header--extended">
  <div class="usa-navbar tmss-banner">
    <div class="usa-logo" id="extended-logo" >
      <em class="usa-logo__text define-logo-text" >
        <img src="/assets/images/TMSS_logo.png" class="define-logo-image" alt="TMSS2.0 Logo" routerLink="/landing">
        <!-- <span style="padding-left:10px" class="font-mono-3xl">
          <span class="define-tmss-version">TMSS 2.0 </span>
        </span> -->
        <div class="font-body-2xs define-tmss-abbr">
            Transportation Management Services Solution 2.0
        </div>
      </em>
    </div>
    <button class="usa-menu-btn">Menu</button>
  </div>
  <nav aria-label="Primary navigation" class="usa-nav">
    <div class="usa-nav__inner">
      <button class="usa-nav__close">
        <img src="./assets/img/close.svg" alt="close" />
      </button>
      <ul class="usa-nav__primary usa-accordion" *ngIf="isUserPresent && isLoggedIn() && userSession(currentUser) && !router.url.includes('userselection')"
      (click)="onNavClick()">
        <li class="usa-nav__primary-item">
          <a class="usa-nav__link" id="home" aria-haspopup="false" aria-expanded="false" routerLink="/landing"
             alt="GSA">Home</a>
        </li>
        <li class="usa-nav__primary-item" *ngIf="(checkUserRole(carrier_user_admin) || checkUserRole(carrier_user_RF))" (click)="onHeaderItemClick('rate filing')" [ngClass]="{'active': activeItem === 'rate filing'}">
          <button class="usa-accordion__button usa-nav__link" aria-expanded="false" aria-controls="extended-nav-section-rate-filing"><span>Rate Filing</span></button>
          <ul id="extended-nav-section-rate-filing" class="usa-nav__submenu" hidden>
            <li class="usa-nav__submenu-item">
              <a class="" role="button" tabindex="0" (click)="rateFilingChange('HHG')" *ngIf="(checkUserRole(carrier_user_admin) ||
              checkUserRole(carrier_user_RF) ) && (checkUserBusinessType(HHG) || checkUserBusinessType(HHG_FRT))">HHG Rate Filing</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" role="button" tabindex="0" (click)="rateFilingChange('FRT')" *ngIf="(checkUserRole(carrier_user_admin) || checkUserRole(carrier_user_RF) ) && (checkUserBusinessType(FRT) || checkUserBusinessType(HHG_FRT))">FRT Rate Filing</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/download" *ngIf="(checkUserRole(carrier_user_admin) || checkUserRole(carrier_user_RF))">File Download</a>
            </li>
          </ul>
        </li>
        <li (click)="onHeaderItemClick('shipment options')" [ngClass]="{'active': activeItem === 'shipment options'}" class="usa-nav__primary-item" *ngIf="(checkUserRole(carrier_user_admin) || checkUserRole(carrier_user) || checkUserRole(carrier_user_RF) || checkUserRole(agency_user) || checkUserRole(agency_admin) || checkUserRole(agency_auditor) || checkUserRole(system_admin)) && checkCarrierStatus(carrier_frt_status_processing)">
          <button class="usa-accordion__button usa-nav__link" aria-expanded="false" aria-controls="extended-nav-section-shipment-options"><span>Shipment Options</span></button>
          <ul id="extended-nav-section-shipment-options" class="usa-nav__submenu" hidden>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/hhgratequery"
                 *ngIf="(checkUserRole(carrier_user_admin) || checkUserRole(carrier_user) || checkUserRole(carrier_user_RF) || checkUserRole(agency_user) || checkUserRole(agency_admin) || checkUserRole(agency_auditor) || checkUserRole(system_admin)) && (checkUserBusinessType(HHG) || checkUserBusinessType(HHG_FRT))">HHG
                Queries</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/freightquery"
                 *ngIf="(checkUserRole(carrier_user_admin) || checkUserRole(carrier_user) || checkUserRole(carrier_user_RF) || checkUserRole(agency_user) || checkUserRole(agency_admin) || checkUserRole(agency_auditor) || checkUserRole(system_admin)) && (checkUserBusinessType(FRT) || checkUserBusinessType(HHG_FRT))">FRT
                Queries</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/freightotoshipmentrequest"
                 *ngIf="(checkUserRole(agency_user) || checkUserRole(agency_admin) || checkUserRole(system_admin)) && (checkUserBusinessType(FRT) || checkUserBusinessType(HHG_FRT)) && !checkUserRole(agency_auditor)">FRT
                OTO Request</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/hhgshipmentreview"
                 *ngIf="(checkUserRole(agency_user) || checkUserRole(carrier_user_admin) || checkUserRole(carrier_user_RF) ||checkUserRole(carrier_user) || checkUserRole(agency_admin) || checkUserRole(agency_auditor) || checkUserRole(system_admin)) && (checkUserBusinessType(HHG) || checkUserBusinessType(HHG_FRT))">HHG
                Shipment</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/frtshipmentreview"
                 *ngIf="(checkUserRole(agency_user) || checkUserRole(carrier_user_admin) || checkUserRole(carrier_user_RF) || checkUserRole(carrier_user) || checkUserRole(agency_admin) || checkUserRole(agency_auditor) || checkUserRole(system_admin)) && (checkUserBusinessType(FRT) || checkUserBusinessType(HHG_FRT))">FRT
                Shipment</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/frtshipmentpod"
                 *ngIf="(checkUserRole(agency_user) || checkUserRole(carrier_user_admin) || checkUserRole(carrier_user_RF) || checkUserRole(carrier_user) || checkUserRole(agency_admin) || checkUserRole(agency_auditor) || checkUserRole(system_admin)) && (checkUserBusinessType(FRT) || checkUserBusinessType(HHG_FRT))">FRT
                Shipment PODs</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/frtonetimebookshipment"
                 *ngIf="(checkUserRole(agency_user) || checkUserRole(agency_admin) || checkUserRole(system_admin)) && (checkUserBusinessType(FRT) || checkUserBusinessType(HHG_FRT)) && !checkUserRole(agency_auditor)">One
                Time Shipment</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/hhguabcalculator"
                 *ngIf="(checkUserRole(agency_user) || checkUserRole(carrier_user_admin) || checkUserRole(carrier_user_RF) ||checkUserRole(carrier_user) || checkUserRole(agency_admin) || checkUserRole(agency_auditor) || checkUserRole(system_admin)) && (checkUserBusinessType(HHG) || checkUserBusinessType(HHG_FRT))">HHG UAB Cost Calculator</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/tspstatusportal"
                 *ngIf="(checkUserRole(agency_user) || checkUserRole(carrier_user_admin) || checkUserRole(carrier_user_RF) ||checkUserRole(carrier_user) || checkUserRole(agency_admin) || checkUserRole(agency_auditor) || checkUserRole(system_admin)) && (checkUserBusinessType(HHG) || checkUserBusinessType(HHG_FRT))">HHG TSPs in Temp Non-Use</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/tspfrtstatusportal"
                 *ngIf="(checkUserRole(agency_user) || checkUserRole(agency_admin) || checkUserRole(agency_auditor) || checkUserRole(system_admin)) && (checkUserBusinessType(FRT) || checkUserBusinessType(HHG_FRT))">FRT TSPs in Temp Non-Use</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/frtsyncadashipmentinvoices"
              *ngIf="checkUserRole(system_admin) && (checkUserBusinessType(FRT) || checkUserBusinessType(HHG_FRT))">FRT Syncada Reconciliation Report</a>
            </li>

          </ul>
        </li>
        <li (click)="onHeaderItemClick('shipment reports')" [ngClass]="{'active': activeItem === 'shipment reports'}"
            class="usa-nav__primary-item" *ngIf="(checkUserRole(carrier_user_admin) || checkUserRole(carrier_user_RF) || checkUserRole(carrier_user) || checkUserRole(system_admin) || checkUserRole(agency_user) ||checkUserRole(agency_admin)) && (checkUserBusinessType(HHG) || checkUserBusinessType(HHG_FRT) || checkUserBusinessType(FRT)) && checkCarrierStatus(carrier_frt_status_processing)">
          <button class="usa-accordion__button usa-nav__link" aria-expanded="false"
                  aria-controls="extended-nav-section-shipment-reports"><span>Shipment Reports</span></button>
          <ul id="extended-nav-section-shipment-reports" class="usa-nav__submenu" hidden>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/hhgQuarterlyReports" *ngIf="(checkUserRole(carrier_user_admin) && (checkUserBusinessType(HHG) || checkUserBusinessType(HHG_FRT)))">Administrative Fee Payments</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/hhgIffSummary" *ngIf="checkUserRole(system_admin) && (checkUserBusinessType(HHG) || checkUserBusinessType(HHG_FRT))">HHG Shipment Reports</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/hhgComprehensiveReport" *ngIf="(checkUserBusinessType(HHG) && (checkUserRole(agency_user) || checkUserRole(agency_admin) || checkUserRole(agency_auditor)))">HHG Shipment Reports</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/tspHhgShpmntRptStatus" *ngIf="checkUserBusinessType(HHG) && (checkUserRole(carrier_user) || checkUserRole(carrier_user_admin) || checkUserRole(carrier_user_RF))">HHG Shipment Reports</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/sitIffSummary" *ngIf="checkUserRole(system_admin)">SIT Shipment Reports</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/sitComprehensiveReport" *ngIf="(checkUserBusinessType(HHG) && (checkUserRole(agency_user) || checkUserRole(agency_admin) || checkUserRole(agency_auditor)) )">SIT Shipment Reports</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/tspSitShpmntRptStatus" *ngIf="(checkUserRole(carrier_user) || checkUserRole(carrier_user_admin) || checkUserRole(carrier_user_RF))">SIT Shipment Reports</a>
            </li>
            <li class="usa-nav__submenu-item" *ngIf="(checkUserBusinessType(FRT) && (checkUserRole(agency_user) || checkUserRole(agency_admin) || checkUserRole(agency_auditor) || checkUserRole(carrier_user_RF) || checkUserRole(carrier_user) || checkUserRole(carrier_user_admin)))">
              <a class="" routerLink="/frtIffSummary" *ngIf="checkUserRole(system_admin)">FRT Shipment Reports</a>
            </li>
            <li class="usa-nav__submenu-item" *ngIf="(checkUserBusinessType(FRT) || checkUserBusinessType(HHG_FRT))">
              <a class="" routerLink="/frtOnTimeSummary">FRT On-Time Shipment Reports</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/negativeShipmentSubmission"
                 *ngIf="(checkUserRole(carrier_user_admin) || checkUserRole(carrier_user) || checkUserRole(carrier_user_RF)) && (checkUserBusinessType(HHG) || checkUserBusinessType(HHG_FRT))">HHG/SIT Negative Shipment Reporting</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/"
                 *ngIf="(checkUserRole(carrier_user_admin) || checkUserRole(carrier_user) || checkUserRole(carrier_user_RF)) && (checkUserBusinessType(HHG) || checkUserBusinessType(HHG_FRT))">XTOS Negative Shipment Reporting</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/iff-upload" *ngIf="(checkUserRole(carrier_user_admin) || checkUserRole(carrier_user) || checkUserRole(carrier_user_RF)) && (checkUserBusinessType(HHG) || checkUserBusinessType(HHG_FRT))">Upload HHG/SIT Shipment Reports</a>
              <a class="" routerLink="/iff-upload" *ngIf="(checkUserRole(carrier_user_admin) || checkUserRole(carrier_user) || checkUserRole(carrier_user_RF)) && checkUserBusinessType(FRT)">Upload Shipment Reports</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/xtosreporting" *ngIf="checkUserRole(system_admin)">XTOS Shipment Reports</a>
              <a class="" routerLink="/tspXtosShpmntRptStatus" *ngIf="(checkUserBusinessType(HHG) && checkUserRole(carrier_user) || checkUserRole(carrier_user_admin) || checkUserRole(carrier_user_RF))">XTOS Shipment Reporting</a>
              <a class="" routerLink="/xtosComprehensiveReport" *ngIf="(checkUserBusinessType(HHG) && (checkUserRole(agency_user) || checkUserRole(agency_admin) || checkUserRole(agency_auditor)) )">XTOS Shipment Reports</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/download" *ngIf="(checkUserRole(carrier_user_admin) || checkUserRole(carrier_user) || checkUserRole(carrier_user_RF))">File Download</a>
            </li>
          </ul>
        </li>
        <li class="usa-nav__primary-item" *ngIf="checkUserRole(system_admin)" (click)="onHeaderItemClick('system admin')" [ngClass]="{'active': activeItem === 'system admin'}">
          <button class="usa-accordion__button usa-nav__link" aria-expanded="false"
                  aria-controls="extended-nav-section-sysadmin"><span>System Admin</span></button>
          <ul id="extended-nav-section-sysadmin" class="usa-nav__submenu" hidden>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/customerapprovallist" *ngIf="checkUserRole(system_admin)">Customer
                (Agency) Approval</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/agencytspsearch" *ngIf="checkUserRole(system_admin)">User
                Administration</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/ratessromaintenance" *ngIf="checkUserRole(system_admin) && checkUserBusinessType(HHG)">Define HHG
                SRO</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/ratesfrtsromaintenance" *ngIf="checkUserRole(system_admin) && checkUserBusinessType(FRT)">Define FRT
                SRO</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/masterdataadmin" *ngIf="checkUserRole(system_admin)">Master Data
                Admin</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/iffrates" *ngIf="checkUserRole(system_admin)">AF Admin</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/frtratesbidcyles"
                 *ngIf="checkUserRole(system_admin) && (checkUserBusinessType(FRT) || checkUserBusinessType(HHG_FRT))">FRT
                Rate Filing Admin</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/hhgratesbidcyles"
                 *ngIf="checkUserRole(system_admin) && (checkUserBusinessType(HHG) || checkUserBusinessType(HHG_FRT))">HHG
                Rate Filing Admin</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/notifyusers"
                 *ngIf="checkUserRole(system_admin)">
                Notify Users</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/download" *ngIf="checkUserRole(system_admin)"
                 [queryParams]="{roleId:currentUser?.userSessionEntity?.roleId}">File Downloads</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/nonusetsp" *ngIf="checkUserRole(system_admin)"
                 [queryParams]="{roleId:currentUser?.userSessionEntity?.roleId}">Revoked TSPs</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/s3admin" *ngIf="checkUserRole(system_admin)">S3 Admin Portal</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/broadcastmessages"
                *ngIf="checkUserRole(system_admin)">
                Broadcast Messages</a>
            </li>

            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/recertifyuser" *ngIf="checkUserRole(system_admin)">Recertify Users</a>
            </li>
          </ul>
        </li>
        <li class="usa-nav__primary-item" (click)="onHeaderItemClick('misc reports')" [ngClass]="{'active': activeItem === 'misc reports'}">
          <button class="usa-accordion__button usa-nav__link" aria-expanded="false"
                  aria-controls="extended-nav-section-misc"><span>Misc Reports</span></button>
          <ul id="extended-nav-section-misc" class="usa-nav__submenu" hidden>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/frtratescsvdownload"
                 *ngIf="(checkUserBusinessType(FRT) || checkUserBusinessType(HHG_FRT))">
                FRT Rates Download</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/hhgratescsvdownload"
                 *ngIf="(checkUserBusinessType(HHG) || checkUserBusinessType(HHG_FRT))">
                HHG Rates Download</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/hhgRatesScopeReport"
                 *ngIf="((checkUserRole(carrier_user_admin) || checkUserRole(carrier_user) || checkUserRole(carrier_user_RF) || checkUserRole(system_admin) || checkUserRole(agency_user) || checkUserRole(agency_admin) || checkUserRole(agency_auditor)) && (checkUserBusinessType(HHG) || checkUserBusinessType(HHG_FRT)))">HHG
                Scope Report</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/mailinglistreport"
                 *ngIf="((checkUserRole(agency_user) || checkUserRole(system_admin) || checkUserRole(agency_admin) || checkUserRole(agency_auditor)) || ((checkUserRole(carrier_user) || checkUserRole(carrier_user_RF) || checkUserRole(carrier_user_admin)) && (checkUserBusinessType(FRT) || checkUserBusinessType(HHG_FRT)))) && checkCarrierStatus(carrier_frt_status_processing)">Mailing
                List</a>
            </li>
            <li class="usa-nav__submenu-item" *ngIf="checkCarrierStatus(carrier_frt_status_processing)">
              <a class="" routerLink="/faiclist">FAIC List</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/frtlist" *ngIf="checkUserRole(system_admin) && checkUserBusinessType(FRT)">FRT Spending Report - Agencies</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/frtTspList" *ngIf="checkUserRole(system_admin) && checkUserBusinessType(FRT)">FRT Spending Report - TSPs</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/hhglist" *ngIf="checkUserRole(system_admin) && checkUserBusinessType(HHG)">HHG Shipment Summary Report</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/carrierrateproc" *ngIf="checkUserRole(system_admin) || ((checkUserRole(carrier_user) || checkUserRole(carrier_user_RF) || checkUserRole(carrier_user_admin)))">TSP Rate Proc Report</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/loginHistoryReport" *ngIf="checkUserRole(system_admin) || checkUserRole(carrier_user_admin) || checkUserRole(agency_admin) || checkUserRole(agency_auditor)">Login History Report</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/hhgRatesQueryReport" *ngIf="checkUserRole(system_admin) && checkUserBusinessType(HHG)">HHG Rates Query Report</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/frtRatesQueryReport" *ngIf="checkUserRole(system_admin) && checkUserBusinessType(FRT)">FRT Rates Query Report</a>
            </li>
            <li class="usa-nav__submenu-item" *ngIf="(checkUserBusinessType(FRT) || checkUserBusinessType(HHG_FRT))">
              <a class="" routerLink="/frtTspRating">FRT TSP Performance Metrics</a>
            </li>
          </ul>
        </li>
        <li class="usa-nav__primary-item" *ngIf="checkUserRole(system_admin)" (click)="onHeaderItemClick('dashboard')" [ngClass]="{'active': activeItem === 'dashboard'}">
          <button class="usa-accordion__button usa-nav__link" aria-expanded="false"
                  aria-controls="extended-nav-section-tableau-dashboards"><span>Dashboards</span></button>
          <ul id="extended-nav-section-tableau-dashboards" class="usa-nav__submenu" hidden>
            <li class="usa-nav__submenu-item">
              <a class="" [routerLink]="['/frtDashboards', 'FRTShipmentReport']"
                 *ngIf="checkUserRole(system_admin) && (checkUserBusinessType(FRT) || checkUserBusinessType(HHG_FRT))">
                FRT Shipment Report</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" [routerLink]="['/frtDashboards', 'FRTShipmentSummary']"
                 *ngIf="checkUserRole(system_admin) && (checkUserBusinessType(FRT) || checkUserBusinessType(HHG_FRT))">
                FRT Shipment Summary</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" [routerLink]="['/frtDashboards', 'ShipmentMaps']"
                 *ngIf="checkUserRole(system_admin) && (checkUserBusinessType(FRT) || checkUserBusinessType(HHG_FRT))">
                Shipment Maps
              </a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" [routerLink]="['/hhgDashboards', 'HHGIFFDashboard']"
                 *ngIf="checkUserRole(system_admin) && (checkUserBusinessType(HHG) || checkUserBusinessType(HHG_FRT))">
                HHG AF Dashboard</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" [routerLink]="['/hhgDashboards', 'HHGIFFSummary']"
                 *ngIf="checkUserRole(system_admin) && (checkUserBusinessType(HHG) || checkUserBusinessType(HHG_FRT))">
                HHG AF Summary</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" [routerLink]="['/hhgDashboards', 'SITIFFDashboard']"
                 *ngIf="checkUserRole(system_admin) && (checkUserBusinessType(HHG) || checkUserBusinessType(HHG_FRT))">
                SIT AF Dashboard</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" [routerLink]="['/hhgDashboards', 'TransitTimes']"
                 *ngIf="checkUserRole(system_admin) && (checkUserBusinessType(HHG) || checkUserBusinessType(HHG_FRT))">
                Transit Times</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" [routerLink]="['/hhgDashboards', 'HHgRateProcStats']"
                 *ngIf="checkUserRole(system_admin) && (checkUserBusinessType(HHG) || checkUserBusinessType(HHG_FRT))">
                HHG Rate Proc Stats</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" [routerLink]="['/hhgDashboards', '3080Reporting']"
                 *ngIf="checkUserRole(system_admin) && (checkUserBusinessType(HHG) || checkUserBusinessType(HHG_FRT))">
                3080 Reporting</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" [routerLink]="['/hhgDashboards', 'TrafficVolume']"
                 *ngIf="checkUserRole(system_admin) && (checkUserBusinessType(HHG) || checkUserBusinessType(HHG_FRT))">
                Traffic Volume</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" [routerLink]="['/hhgDashboards', 'RateTrendsLinehaul']"
                 *ngIf="checkUserRole(system_admin) && (checkUserBusinessType(HHG) || checkUserBusinessType(HHG_FRT))">
                 HHG Rate Trends</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" [routerLink]="['/hhgDashboards', 'ErrorStats']"
                 *ngIf="checkUserRole(system_admin) && (checkUserBusinessType(HHG) || checkUserBusinessType(HHG_FRT))">
                 HHG Rate Filing Error Stats</a>
            </li>
          </ul>
        </li>
        <li class="usa-nav__primary-item" *ngIf="(checkUserBusinessType(HHG_FRT) || checkUserBusinessType(HHG)) && !checkUserRole(agency_auditor)"
            (click)="onHeaderItemClick('3080')" [ngClass]="{'active': activeItem === '3080'}">
          <button class="usa-accordion__button usa-nav__link" aria-expanded="false"
                  aria-controls="extended-nav-section-3080"><span>GSA 3080</span></button>
          <ul id="extended-nav-section-3080" class="usa-nav__submenu" hidden>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/adminSurvey" *ngIf="checkUserRole(system_admin)">GSA 3080 Admin</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/surveyAdminReports" *ngIf="checkUserRole(system_admin)">GSA 3080
                TSP Evaluation Report</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/summaryReports" *ngIf="checkUserRole(system_admin)">GSA 3080
                Comprehensive Report</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/amcReports"
                 *ngIf="(checkUserRole(agency_user) || checkUserRole(agency_admin) || checkUserRole(system_admin))">GSA
                3080 AMC Report</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/carrierReports"
                 *ngIf="(checkUserRole(carrier_user_admin) || checkUserRole(carrier_user) || checkUserRole(carrier_user_RF))">GSA
                3080 TSP Report</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/3080-upload"
                 *ngIf="(checkUserRole(carrier_user_admin) || checkUserRole(carrier_user) || checkUserRole(carrier_user_RF))">GSA
                3080 File Upload</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/3080-download"
                 *ngIf="(checkUserRole(carrier_user_admin) || checkUserRole(carrier_user) || checkUserRole(carrier_user_RF))">GSA
                3080 File Download</a>
            </li>
            <!-- Initiate 3080 inside login -->
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/gsa3080initiation"
                 *ngIf="(checkUserRole(carrier_user_admin) || checkUserRole(carrier_user) || checkUserRole(carrier_user_RF))">GSA 3080 Initiation</a>
            </li>
          </ul>
        </li>
        <li class="usa-nav__primary-item" (click)="onHeaderItemClick('other')" [ngClass]="{'active': activeItem === 'other'}">
          <button class="usa-accordion__button usa-nav__link" aria-expanded="false"
                  aria-controls="extended-nav-section-other"><span>Other</span></button>
          <ul id="extended-nav-section-other" class="usa-nav__submenu" hidden>
            <!-- <li class="usa-nav__submenu-item">
              <a class="" routerLink="/userprofile" [queryParams]="{userId:currentUser.id}">User Profile</a>
            </li> -->
            <!-- <li class="usa-nav__submenu-item">
              <a class="" routerLink="/landing"
                 *ngIf="checkUserRole(carrier_user_admin) && (checkUserBusinessType(HHG) || checkUserBusinessType(HHG_FRT))">HHG
                Rate Update Contact Info</a>
            </li> -->
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/userselection" *ngIf="currentUser?.multiUserAccount">Switch User
                Account</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/localagents" *ngIf="checkUserRole(carrier_user_admin)">Local
                Agents</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/customerapprovallist" *ngIf="checkUserRole(agency_admin) && !checkUserRole(agency_auditor)">User
                Approval</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/documentmanagement"
                 *ngIf="(checkUserRole(system_admin) || checkUserRole(carrier_user_admin))">Document Management</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/downloadcurrentpastrates"
                 *ngIf="(checkUserRole(carrier_user_admin) || checkUserRole(carrier_user) || checkUserRole(carrier_user_RF) || checkUserRole(system_admin))">File Downloads</a>
                <a class="" routerLink="/download"
                 *ngIf="(checkUserRole(agency_user) || checkUserRole(agency_admin) || checkUserRole(agency_auditor))">File Downloads</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a class="" routerLink="/userpreferences"
                 *ngIf="(checkUserRole(carrier_user_admin) || checkUserRole(carrier_user) || checkUserRole(carrier_user_RF) || checkUserRole(agency_user) || checkUserRole(agency_admin) || checkUserRole(agency_auditor) || checkUserRole(system_admin))">Data
                View Preferences</a>
            </li>

          </ul>
        </li>
      </ul>
      <div class="usa-nav__secondary" style="top:-200px !important">
        <ul class="usa-nav__secondary-links define-header-color text-bold">
          <li class="usa-nav__secondary-item" *ngIf="isUserPresent && isLoggedIn()">
            Welcome:&nbsp;
            <img src="assets/images/user_icon.svg" alt="user_icon">
          </li>
          <li class="usa-nav__secondary-item" *ngIf="isUserPresent && isLoggedIn()">
            <a [tooltip]="template" placement="bottom" routerLink="/userprofile"
               [queryParams]="{userId:currentUser?.id, organizationId:currentUser?.userSessionEntity?.organizationId}">
              {{ currentUser ? currentUser.firstName : '' }} {{currentUser ? currentUser.lastName : '' }} ({{currentUser?.roles[0]?.role}})</a>
          </li>
          <li class="usa-nav__secondary-item" *ngIf="isLoggedIn()">
            <a routerLink="" (click)="logout()" title="Logout">Logout</a>
          </li>
          <li class="usa-nav__secondary-item" *ngIf="!isLoggedIn()">
            <a href="javascript:void(0);" *ngIf="!isLoggedIn() && this.currentUrl !== '/signon'" (click)="goToSignon()" title="Login">Login</a>
          </li>
          <li class="usa-nav__secondary-item" *ngIf="!isLoggedIn()">
            <a routerLink="/customerregistration" title="Register"> New Federal Customer? Register Here</a>
          </li>
          <li class="usa-nav__secondary-item" *ngIf="!isLoggedIn()">
            <a routerLink="/survey" title="Electronic GSA 3080">Electronic GSA 3080</a>
          </li>
        </ul>
        <section aria-label="Search component" style="width: 100%;">
          <form class="usa-search usa-search--small" role="search">
            <label class="usa-sr-only" for="search-field">Search</label>
            <input
              class="usa-input"
              id="search-field"
              type="search"
              name="search"
              placeholder="Search All Government"
              (keyup.enter)="openSearchApi()"
              [(ngModel)]="searchPhrase"
            />
            <button class="usa-button" type="submit" (click)="openSearchApi()">
              <img
                src="/assets/img/search.png"
                class="usa-search__submit-icon"
                alt="Search"
              />
            </button>
          </form>
        </section>
      </div>
    </div>
  </nav>
</header>
<main id="main-content"></main>
<section *ngIf="isUserPresent && isLoggedIn() && userSession(currentUser)">
  <app-bread-crumb-navigation></app-bread-crumb-navigation>
</section>
<!-- TODO Redesign for better look and feel-->
<ng-template #template>
  <strong style="color: #333333 !important; text-align: center !important; text-decoration: underline !important;">User
    Profile</strong> <br>
  <li style="text-align: left;">{{currentUser?.firstName}} {{currentUser?.lastName}} </li>
  <li style="text-align: left;">{{getRoleName(currentUser)}}</li>
  <li style="text-align: left;">Email: {{currentUser?.email}}</li>
  <li *ngIf="currentUser?.agencyBureauName" style="text-align: left;">Agency: {{currentUser?.agencyBureauName}} </li>
  <li *ngIf="currentUser?.scac" style="text-align: left;">SCAC: {{currentUser?.scac}} </li>
  <li *ngIf="currentUser?.scacName" style="text-align: left;">TSP Name: {{currentUser?.scacName}} </li>
  <li *ngIf="currentUser?.permissions" style="text-align: left;">Permissions: {{currentUser?.permissions}} </li>
</ng-template>
